import {
  CONNECT_CHAT,
  CONNECT_CHAT_SUCCESS,
  CONNECT_CHAT_FAIL,
  DISCONNECT_CHAT,
  SET_ONLINE_USERS,
  FETCH_MESSAGES,
  FETCH_MESSAGES_SUCCESS,
  FETCH_MESSAGES_FAIL,
  SEND_MESSAGE,
  SEND_MESSAGE_SUCCESS,
  SEND_MESSAGE_FAIL,
  RECEIVE_MESSAGE,
  MARK_MESSAGES_READ,
  SET_ACTIVE_CONVERSATION,
  CLEAR_ACTIVE_CONVERSATION,
  FETCH_NOTIFICATIONS,
  FETCH_NOTIFICATIONS_SUCCESS,
  FETCH_NOTIFICATIONS_FAIL,
  RECEIVE_NOTIFICATION,
  MARK_NOTIFICATION_READ,
  MARK_ALL_NOTIFICATIONS_READ,
  TOGGLE_CHAT_PANEL,
  SET_CHAT_PANEL_OPEN,
} from "./actionTypes"

const INIT_STATE = {
  connected: false,
  connecting: false,
  error: null,
  onlineUsers: [],
  messages: {},
  messagesLoading: false,
  activeConversation: null,
  unreadCounts: {},
  notifications: [],
  notificationsLoading: false,
  unreadNotificationCount: 0,
  chatPanelOpen: false,
}

const realtimeChat = (state = INIT_STATE, action) => {
  switch (action.type) {
    // Connection
    case CONNECT_CHAT:
      return {
        ...state,
        connecting: true,
        error: null,
      }

    case CONNECT_CHAT_SUCCESS:
      return {
        ...state,
        connected: true,
        connecting: false,
      }

    case CONNECT_CHAT_FAIL:
      return {
        ...state,
        connected: false,
        connecting: false,
        error: action.payload,
      }

    case DISCONNECT_CHAT:
      return {
        ...state,
        connected: false,
        connecting: false,
      }

    // Users
    case SET_ONLINE_USERS:
      return {
        ...state,
        onlineUsers: action.payload,
      }

    // Messages
    case FETCH_MESSAGES:
      return {
        ...state,
        messagesLoading: true,
      }

    case FETCH_MESSAGES_SUCCESS:
      return {
        ...state,
        messages: {
          ...state.messages,
          [state.activeConversation]: action.payload,
        },
        messagesLoading: false,
      }

    case FETCH_MESSAGES_FAIL:
      return {
        ...state,
        messagesLoading: false,
        error: action.payload,
      }

    case SEND_MESSAGE:
      return state

    case SEND_MESSAGE_SUCCESS: {
      const msg = action.payload
      const convId = msg.recipientId
      return {
        ...state,
        messages: {
          ...state.messages,
          [convId]: [...(state.messages[convId] || []), msg],
        },
      }
    }

    case SEND_MESSAGE_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case RECEIVE_MESSAGE: {
      const msg = action.payload
      const senderId = msg.senderId
      const isCurrentConv = state.activeConversation === senderId
      return {
        ...state,
        messages: {
          ...state.messages,
          [senderId]: [...(state.messages[senderId] || []), msg],
        },
        unreadCounts: isCurrentConv
          ? state.unreadCounts
          : {
              ...state.unreadCounts,
              [senderId]: (state.unreadCounts[senderId] || 0) + 1,
            },
      }
    }

    case MARK_MESSAGES_READ:
      return {
        ...state,
        unreadCounts: {
          ...state.unreadCounts,
          [action.payload]: 0,
        },
      }

    // Conversations
    case SET_ACTIVE_CONVERSATION:
      return {
        ...state,
        activeConversation: action.payload,
        unreadCounts: {
          ...state.unreadCounts,
          [action.payload]: 0,
        },
      }

    case CLEAR_ACTIVE_CONVERSATION:
      return {
        ...state,
        activeConversation: null,
      }

    // Notifications
    case FETCH_NOTIFICATIONS:
      return {
        ...state,
        notificationsLoading: true,
      }

    case FETCH_NOTIFICATIONS_SUCCESS:
      return {
        ...state,
        notifications: action.payload,
        notificationsLoading: false,
        unreadNotificationCount: action.payload.filter((n) => !n.read).length,
      }

    case FETCH_NOTIFICATIONS_FAIL:
      return {
        ...state,
        notificationsLoading: false,
        error: action.payload,
      }

    case RECEIVE_NOTIFICATION:
      return {
        ...state,
        notifications: [action.payload, ...state.notifications],
        unreadNotificationCount: state.unreadNotificationCount + 1,
      }

    case MARK_NOTIFICATION_READ:
      return {
        ...state,
        notifications: state.notifications.map((n) =>
          n.id === action.payload ? { ...n, read: true } : n
        ),
        unreadNotificationCount: Math.max(0, state.unreadNotificationCount - 1),
      }

    case MARK_ALL_NOTIFICATIONS_READ:
      return {
        ...state,
        notifications: state.notifications.map((n) => ({ ...n, read: true })),
        unreadNotificationCount: 0,
      }

    // UI State
    case TOGGLE_CHAT_PANEL:
      return {
        ...state,
        chatPanelOpen: !state.chatPanelOpen,
      }

    case SET_CHAT_PANEL_OPEN:
      return {
        ...state,
        chatPanelOpen: action.payload,
      }

    default:
      return state
  }
}

export default realtimeChat

// Selectors
export const selectOnlineUsers = (state) => state.realtimeChat.onlineUsers
export const selectMessages = (state, conversationId) =>
  state.realtimeChat.messages[conversationId] || []
export const selectActiveConversation = (state) =>
  state.realtimeChat.activeConversation
export const selectUnreadCounts = (state) => state.realtimeChat.unreadCounts
export const selectTotalUnreadMessages = (state) =>
  Object.values(state.realtimeChat.unreadCounts).reduce((a, b) => a + b, 0)
export const selectNotifications = (state) => state.realtimeChat.notifications
export const selectUnreadNotificationCount = (state) =>
  state.realtimeChat.unreadNotificationCount
export const selectChatPanelOpen = (state) => state.realtimeChat.chatPanelOpen
export const selectConnected = (state) => state.realtimeChat.connected
